import { css } from 'styled-components';

export const GlobalModalStyles = css`
  .modal-backdrop-1 {
    z-index: 1040;
  }

  .modal-backdrop-2 {
    z-index: 1140;
  }

  .modal-backdrop-3 {
    z-index: 1240;
  }

  .modal-backdrop-4 {
    z-index: 1340;
  }
`;
